(() => {
  const initialise = () => {
    document.querySelectorAll('.tempo-nav-details').forEach(details => {
      if (details.dataset.tempoReady) return;
      details.dataset.tempoReady = 'true';
      details.addEventListener('toggle', () => {
        if (!details.open) return;
        details.closest('ul')?.querySelectorAll('.tempo-nav-details[open]').forEach(other => { if (other !== details) other.open = false; });
      });
    });
    document.querySelectorAll('[data-home-category]').forEach(card => {
      const source = document.querySelector('.main_nav [data-tempo-category="' + card.dataset.homeCategory + '"] .tempo-category-links');
      const target = card.querySelector('.tempo-home-directory');
      if (source && target) target.replaceChildren(source.cloneNode(true));
    });
  };
  document.addEventListener('click', event => {
    document.querySelectorAll('.tempo-nav-details[open],.tempo-mobile-native[open]').forEach(details => { if (!details.contains(event.target)) details.open = false; });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const mobile = document.querySelector('.tempo-mobile-native[open]');
    const category = event.target.closest?.('.tempo-nav-details[open]');
    if (category) { category.open = false; category.querySelector('summary')?.focus(); }
    else if (mobile) { mobile.open = false; mobile.querySelector('summary')?.focus(); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise); else initialise();
  window.addEventListener('load', initialise);
  document.addEventListener('shopify:section:load', initialise);
  if (window.InstantClick?.on) window.InstantClick.on('change', initialise);
})();

